module.exports = __webpack_public_path__ + "img/123.e5953e16.jpg";